<template>
  <div class="whiteBg main">
    <div class="flex clockBox">
      <van-icon name="checked" color="#07c160" />
    </div>
    <div class="title">
      <h2>支付成功</h2>
    </div>
    <van-button class="pay_btn" type="primary" @click="handleCancel()"
      >返回</van-button
    >
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  // beforeRouteLeave(to, from, next) {
  //   if (to.name === 'home') {
  //     to.meta.keepAlive = false // 让home页面不缓存
  //   }
  //   next()
  // },
  methods: {
    handleCancel() {
      global.wx.closeWindow()
    }
  }
}
</script>
<style lang="scss" scoped>
.main {
  position: fixed;
  width: 100vw;
  height: 100vh;
  padding-top: 48px;
  text-align: center;
  .clockBox {
    margin: 0 0 32px;
  }
  .title {
    margin: 0 0 10px;
    h2 {
      margin-bottom: 16px;
    }
  }
  .orderInfo {
    width: 80%;
    margin: 10px auto;
    padding: 5%;
    padding-top: 5px;
    text-align: right;
    .left {
      width: 80px;
    }
    :nth-child(2) {
      flex: 1;
    }
  }
  .pay_btn {
    margin-top: 40px;
    width: 50vw;
    font-size: 17px;
    font-weight: 700;
  }
}
.van-icon {
  font-size: 60px !important;
}
</style>
